package dev.kuml.portal.web.i18n.strings

public interface HeaderStrings {
    public val logout: String

    public val allPlainStrings: List<String> get() = listOf(logout)
}

public object HeaderStringsDe : HeaderStrings {
    override val logout = "Abmelden"
}

public object HeaderStringsEn : HeaderStrings {
    override val logout = "Log out"
}
